import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from './services/auth-service/auth.service';
import { MonitoringService } from './services/monitoring-service/monitoring.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(private monitoringService: MonitoringService, private authService: AuthService) {}

  public ngOnInit(): void {
    // Start monitoring
    this.monitoringService.initialize();
    // Start the authentication process
    this.authService.initAuth();
  }
}
